import { getLopUrl } from './getLopUrl'
import { getSessionValue } from '../default/getSessionValue'

const SESSION_ID = 'tdMainFunnel'
const SESSION_KEYS = [
  'fbc',
  'fbp',
  'utm_campaign',
  'sub1',
  'sub2',
  'sub3',
  'sub4',
  'sub5',
] // needed for lop events - append to query

/**
 * @param {{ flow: string, event: string }} params
 */
export function submitLopEvent({ flow, event }) {
  if (new URLSearchParams(window.location.search).get('skiptesting') === 'true')
    return // don't fire lop events if skiptesting is true

  const session_uuid = getSessionValue(SESSION_ID, 'unique_session_id') // pull uuid from session (changes on every funnel entry but retained for chat events)
  const snakeEvent = event
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/[\s-]+/g, '_')
    .toLowerCase()
  const apiBase = getLopUrl()
  const endpoint = '/lop/flows/event'
  const url = `${apiBase}${endpoint}`

  const queryParams = new URLSearchParams(window.location.search)
  queryParams.delete('l') // strip encoded l param in chat pages
  SESSION_KEYS.forEach((key) => {
    const val = getSessionValue(SESSION_ID, key)
    if (val) queryParams.set(key, val)
  })

  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      flow,
      query: `?${queryParams.toString()}`,
      event_type: snakeEvent,
      website: window.location.origin,
      session_uuid,
    }),
  }).catch((error) => {
    console.error('Error submitting LOP event:', error)
  })
}
